export const EXSBPRICEGROUP_SHOW_RESET = 'EXSBPRICEGROUP_SHOW_RESET'
export const EXSBPRICEGROUP_SHOW_SET_ERROR = 'EXSBPRICEGROUP_SHOW_SET_ERROR'
export const EXSBPRICEGROUP_SHOW_SET_RETRIEVED = 'EXSBPRICEGROUP_SHOW_SET_RETRIEVED'
export const EXSBPRICEGROUP_SHOW_TOGGLE_LOADING = 'EXSBPRICEGROUP_SHOW_TOGGLE_LOADING'
